import React, { forwardRef, useState, useEffect } from 'react';
const isDingTalk = (() => {
    try {
        return navigator.userAgent.toLocaleLowerCase().includes('dingtalk');
    }
    catch { }
    return false;
})();
function isClient() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
export function measureHeight() {
    if (!isClient())
        return null;
    if (isDingTalk)
        return null;
    return window.innerHeight;
}
export function use100vh() {
    const [height, setHeight] = useState(measureHeight);
    useEffect(() => {
        if (isDingTalk)
            return;
        const setMeasuredHeight = () => {
            setHeight(measureHeight());
        };
        window.addEventListener('resize', setMeasuredHeight);
        return () => {
            window.removeEventListener('resize', setMeasuredHeight);
        };
    }, []);
    return height;
}
const Div100vh = forwardRef(({ style, ...other }, ref) => {
    const height = use100vh();
    const styleWithRealHeight = {
        ...style,
        height: height ? `${height}px` : '100vh',
    };
    return React.createElement("div", { ref: ref, style: styleWithRealHeight, ...other });
});
Div100vh.displayName = 'Div100vh';
export default Div100vh;
